import Icon from "../Icon";

type CloseButtonProps = {
  onClose: () => void;
};
export default function CloseButton({ onClose }: CloseButtonProps) {
  return <Icon name="closeCircle" onClick={onClose} size={26} tabIndex={0} />;
}
